export default {
  dsn: import.meta.env.VITE_APP_SENTRY_DSN as string,
  env: (import.meta.env.VITE_APP_SENTRY_ENV as string) ?? "local",
  tracesSampleRate: parseFloat((import.meta.env.VITE_APP_SENTRY_TRACES_SAMPLE_RATE as string) ?? "0.0"),
};
